import { connectFunctionsEmulator, getFunctions, httpsCallable } from 'firebase/functions';

import { firebaseApp } from './client';

const functionsInstance = getFunctions(firebaseApp, 'us-central1');

const useFunctionsEmulator =
  import.meta.env.DEV &&
  (import.meta.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true' ||
    import.meta.env.VITE_USE_FUNCTIONS_EMULATOR === 'true');

if (useFunctionsEmulator) {
  const host = import.meta.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || '127.0.0.1';
  const port = Number(import.meta.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5001);
  connectFunctionsEmulator(functionsInstance, host, port);
}

export function getCallableErrorMessage(error) {
  if (!error) {
    return 'Request failed.';
  }

  if (typeof error.message === 'string' && error.message.trim()) {
    return error.message;
  }

  if (typeof error.details === 'string' && error.details.trim()) {
    return error.details;
  }

  return error.code || 'Request failed.';
}

export async function callFunction(name, data = {}) {
  const callable = httpsCallable(functionsInstance, name);
  const result = await callable(data);
  return result.data;
}
